import React from "react"
import { Link } from "gatsby"
import tw, { styled } from "twin.macro"

import LinkArrow from "images/icons/application-link.svg"

const Frame = styled.div`
  padding-top: 48px;
  width: 300px;
`

const AppSlide = styled.div`
  ${tw`mx-auto`}
  opacity: 0.81;
  background-image: linear-gradient(180deg, #323232 0%, #000000 100%);
  padding: 8px;
  border-radius: 4px;
  width: 211px;
  @media (min-width: 640px) {
    width: 268px;
  }
`

const Icon = styled.div`
  ${tw`mx-auto`}
  heigh: 48px;
  margin-top: -32px;
  margin-bottom: 8px;
  width: 48px;
`

const Title = styled.h4`
  ${tw`font-display text-white text-center`}
  font-size: 13.6px;
  line-height: 20px;
  @media (min-width: 640px) {
    font-size: 17px;
    line-height: 22px;
  }
`

const Description = styled.div`
  ${tw`font-body text-white text-center mb-2`}
  font-size: 10.4px;
  line-height: 17.6px;
  @media (min-width: 640px) {
    font-size: 13px;
    line-height: 22px;
  }
`

const Arrow = styled.div`
  ${tw`mx-auto`}
  height: 13.6px;
  width: 28.8px;
  @media (min-width: 640px) {
    height: 17px;
    width: 36px;
  }
`

export default ({ description, icon, link, title }) => (
  <Frame>
    <Link to={link}>
      <AppSlide>
        <Icon>{icon}</Icon>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Arrow>
          <img src={LinkArrow} alt="Find out more" />
        </Arrow>
      </AppSlide>
    </Link>
  </Frame>
)
